var _rect, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmergencyContact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "#FFF1EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9 32.64H16.3a3.11 3.11 0 01-2.22-.87 2.98 2.98 0 01-.89-2.17V17.44a2.93 2.93 0 01.9-2.17 3.06 3.06 0 012.21-.87h16.58a3.12 3.12 0 012.22.87 2.98 2.98 0 01.89 2.17V29.6a2.93 2.93 0 01-.9 2.17 3.06 3.06 0 01-2.2.87zM15.26 19.37V29.6a.94.94 0 00.29.73.98.98 0 00.75.28h16.58a1 1 0 00.75-.28.96.96 0 00.29-.73V19.37l-8.7 5.97c-.2.12-.41.19-.63.2a1.5 1.5 0 01-.62-.2l-8.7-5.97zm1.04-2.94a1.02 1.02 0 00-.93.6l9.22 6.29 9.22-6.28a.98.98 0 00-.37-.45c-.16-.1-.36-.16-.56-.16H16.31z",
    fill: "#FF9066"
  })));
}
export default SvgEmergencyContact;